import { render, staticRenderFns } from "./MaterialEdit.vue?vue&type=template&id=60d42bb3&"
import script from "./MaterialEdit.js?vue&type=script&lang=js&"
export * from "./MaterialEdit.js?vue&type=script&lang=js&"
import style0 from "./MaterialEdit.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports